import { useState } from 'react';
import { Button } from '../../ds/components';
import styles from './RecoveryCodes.module.css';

/** The ten recovery codes, shown once, with a copy button (Einstellungen 16/17, M8). */
export function RecoveryCodes({ codes }: { codes: string[] }) {
  const [copied, setCopied] = useState<'done' | 'failed' | null>(null);

  async function copy() {
    try {
      await navigator.clipboard.writeText(codes.join('\n'));
      setCopied('done');
    } catch {
      setCopied('failed');
    }
  }

  return (
    <div className={styles.wrap}>
      <ol className={styles.codes} aria-label="Wiederherstellungscodes">
        {codes.map((code) => (
          <li key={code}>{code}</li>
        ))}
      </ol>
      <div className={styles.actions}>
        <Button variant="secondary" size="small" onClick={() => void copy()}>
          Codes kopieren
        </Button>
        {copied === 'done' ? <span className={styles.copied}>In die Zwischenablage kopiert.</span> : null}
        {copied === 'failed' ? (
          <span className={styles.failed}>Kopieren nicht möglich — bitte notieren Sie die Codes.</span>
        ) : null}
      </div>
    </div>
  );
}
